import React from "react";
import FormHelperText from "@material-ui/core/FormHelperText";

export default function FormValidationErrorMessage(props) {
  // //console.log("Check Error Message ", props.errors[props.name]);
  // //console.log("Props Erros ", props.errors);
  // //console.log("ISmANUAL",props.errors[props.name].isManual);
  //console.log("props", props.errors[props.name]);
  if (props.errors[props.name] && props.errors[props.name].isManual && props.errors[props.name].isManual == true) {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix}
      </FormHelperText>
    );
  }
  else if (!props.errors[props.name]) {
    // return false;
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + " is required"}
      </FormHelperText>
    );
  } else if (props.errors[props.name].ref.type === "checkbox") {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + " Should be checked"}
      </FormHelperText>
    );
  }

  else if (props.errors[props.name].type === "max") {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix +
          " Should be minimum " +
          props.errorMessageMinValue +
          " and maximum " +
          props.errorMessageMaxValue}
      </FormHelperText>
    );

  }
  else if (props.errors[props.name].type === "min") {
    let errorMessageMaxValue = props.errorMessageMaxValue ? " and maximum " +
      props.errorMessageMaxValue : ""
    return (

      <FormHelperText error={true}>
        {props.errorMessagePrefix +
          " Should be minimum " +
          props.errorMessageMinValue +
          errorMessageMaxValue}
      </FormHelperText>
    );

  }
  else if (props.errors[props.name].type === "validate" && props.dateValidationFailed != true) {

    if (props.errorMessageMaxValue) {
      return (
        <FormHelperText error={true}>
          {props.errorMessagePrefix +
            " Cannot be greater than " +
            props.errorMessageMaxValue}
        </FormHelperText>
      );
    } else {
      return (
        <FormHelperText error={true}>
          {props.errorMessagePrefix + " is required"}
        </FormHelperText>
      );
    }


  }

  else if (props.errors[props.name].type === "validate" && props.dateValidationFailed == true) {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix +
          " Cannot be less than " +
          props.errorMessageMaxValue}
      </FormHelperText>
    );

  }

  else if (props.errors[props.name].ref.type === "number") {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + " Should be greater than 0"}
      </FormHelperText>
    );
  } else {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + " is required"}
      </FormHelperText>
    );
  }
}
